import Vuex from "vuex";
import Vue from "vue";
import parseJwt from "../helperFunctions/ParseJWT";
import users from "./modules/users";
import psclients from "./modules/psclients";
import router from "../router/router";

Vue.use(Vuex);

let CLIENT_ID = "PS-Authenticate-UI";
let SCOPE = "PSAuthenticate";
let TOKEN_REFRESH_TIMESPAN = 7200; // (2-hours) time before token expires, refresh token now. - in seconds
export default new Vuex.Store({
    modules: {
        users,
        psclients,
    },
    state: {
        users: [],
        token: localStorage.getItem("token") || "",
        status: "",
        ssoOption: "",
        isLoggingOut: false,
        mfaSessionId: "",
        mfaReset: false,
        browserId: "",
        currentUser: "",
    },
    mutations: {
        applicationAuthError(state, token) {
            state.token = "";
            state.status = "error";
        },
        authSuccess(state, token) {
            state.token = token;
            state.status = "success";
        },
        authError(state) {
            state.token = "";
            state.status = "error";
        },
        authLogout(state) {
            state.token = "";
            state.isLoggingOut = true;
        },
        setSsoOption(state, option) {
            state.ssoOption = option;
        },
        setUsersWithSameEmail(state, users) {
            state.users = users;
        },
        setContacts(state, contacts) {
            state.contacts = contacts;
        },
    },
    actions: {
        fetchContacts(context) {
            axios.get("/contact").then((response) => {
                context.commit("setContacts", response.data.data);
                // this.contacts=response.data.data;
            });
        },
        ValidateAccessToken() {
            return new Promise((resolve, reject) => {
                let headers = {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: "Basic UFNBdXRoZW50aWNhdGU6bkl0UmFNbk90U2E=",
                    Accept: "application/json",
                };

                const token = localStorage.getItem("token");

                axios
                    .post(localConfig.authenticationURL + "/connect/introspect", "token=" + token, {
                        headers: headers,
                    })
                    .then((response) => {
                        if (response.data.active) {
                            resolve();
                        } else reject(response); //Active=false
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        adminLogin() {
            if (localStorage.getItem("token") != null)
                localStorage.removeItem("token");
            if (localStorage.getItem("access_token") != null)
                localStorage.removeItem("access_token");
            if (localStorage.getItem("refresh_token") != null)
                localStorage.removeItem("refresh_token");
            if (window.token != null)
                window.token = null;
            if (window.user != null)
                window.user = null;
            router.push({path: "/login", query: {ReturnURL: "Home", pscg: "05a5ab9b-8579-4509-1234-61c778b62d5e", scp: "PSAuthenticate", cid: "PS-Authenticate-UI", v: "4.0.0.0", useActablStyles: "Y" }});
        },
        login(context, payload) {
            return new Promise((resolve, reject) => {
                let headers = {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/x-www-form-urlencoded",
                };
                var querystring = require("querystring");
                // Get token for application
                axios
                    .post(
                        localConfig.authenticationURL + "/api/login",
                        querystring.stringify(payload),
                        { headers: headers }
                    )
                    .then((response) => {
                        context.commit("authSuccess", response.data.access_token);
                        resolve(response);
                    })
                    .catch((error) => {
                        //Although the user successfully logged into SSO, Logging into the requested application failed.
                        context.commit("applicationAuthError");
                        console.log(error);
                        reject(error);
                    });
            });
        },
        generateMfa() {
            return new Promise((resolve, reject) => {
                let headers = {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/x-www-form-urlencoded",
                };
                var querystring = require("querystring");
                let payload = {
                    sessionId: this.state.mfaSessionId,
                };
                axios
                    .post(
                        localConfig.authenticationURL + "/api/mfa/GenerateMfa",
                        querystring.stringify(payload),
                        { headers: headers }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        //Although the user successfully logged into SSO, Logging into the requested application failed.
                        reject(error);
                    });
            });
        },
        submitMfaCode(context, payload) {
            return new Promise((resolve, reject) => {
                let headers = {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/x-www-form-urlencoded",
                };
                var querystring = require("querystring");

                if (payload.mfaReset) {
                    let resetPayload = {
                        mfaCode: payload.mfaCode,
                        sessionId: payload.sessionId,
                        mfaSecret: payload.mfaSecret,
                    };
                    axios
                        .post(
                            localConfig.authenticationURL + "/api/mfa/Reset",
                            querystring.stringify(resetPayload),
                            { headers: headers }
                        )
                        .then((response) => {
                            context.commit("authSuccess", response.data.access_token);
                            resolve(response);
                        });
                } else {
                    let ValidatePayload = {
                        mfaCode: payload.mfaCode,
                        sessionId: payload.sessionId,
                    };

                    axios
                        .post(
                            localConfig.authenticationURL + "/api/mfa/Validate",
                            querystring.stringify(ValidatePayload),
                            { headers: headers }
                        )
                        .then((response) => {
                            context.commit("authSuccess", response.data.access_token);
                            resolve(response);
                        });
                }
            });
        },

        internalSsoLogin(context, payload) {
            return new Promise((resolve, reject) => {
                let headers = {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/x-www-form-urlencoded",
                };

                var querystring = require("querystring");
                axios
                    .post(
                        localConfig.authenticationURL + "/connect/token",
                        querystring.stringify(payload),
                        { headers: headers }
                    )
                    .then((response) => {
                        context.commit("authSuccess", response.data.access_token);
                        resolve(response);
                    })
                    .catch((error) => {
                        //Although the user successfully logged into SSO, Logging into the requested application failed.
                        context.commit("applicationAuthError");
                        console.log(error);
                        reject(error);
                    });
            });
        },

        logout(context) {
            return new Promise((resolve, reject) => {
                context.commit("authLogout");
                if (localStorage.getItem("token") != null)
                    localStorage.removeItem("token");
                if (localStorage.getItem("access_token") != null)
                    localStorage.removeItem("access_token");
                if (localStorage.getItem("refresh_token") != null)
                    localStorage.removeItem("refresh_token");
                delete axios.defaults.headers.common["Authorization"];

                if (window.token != null)
                    window.token = null;
                if (window.user != null)
                    window.user = null;

                resolve();
            });
        },

        resetPasswordRequest(context, payload) {
            return new Promise((resolve, reject) => {
                let headers = {
                    Ps_Client: payload.pscg,
                    returnurl: payload.appUrl,
                };
                axios
                    .post(
                        localConfig.authenticationURL + "/api/passwordsetrequest",
                        payload,
                        { headers: headers }
                    )
                    .then((response) => {
                        let accessToken = response.data.access_token;
                        context.commit("passwordSetRequestSuccess", accessToken);
                        localStorage.setItem("token", accessToken);
                        axios.defaults.headers.common["Authorization"] =
              "Bearer " + accessToken;
                        resolve(response);
                    })
                    .catch((error) => {
                        localStorage.removeItem("token");
                        context.commit("passwordSetRequestError");
                        console.log(error);
                        reject(error);
                    });
            });
        },

        setPassword(context, payload) {
            return new Promise((resolve, reject) => {
                let headers = {
                    Authorization: "bearer " + payload.token,
                };

                axios
                    .post(
                        localConfig.authenticationURL + "/api/setpassword",
                        { Password: payload.password },
                        { headers: headers }
                    )
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        isLoggedIn: (context, data) => {
            var refreshtoken = data[0];
            //   new Promise((resolve,reject)=>{
            console.log("refresh token found...validating");

            const headers = {
                "Access-Control-Allow-Origin": "*",
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: "",
            };

            const payload = {
                grant_type: "refresh_token",
                client_id: "PSAuthSSO",
                scope: "PSAuthenticateSSO offline_access",
                refresh_token: refreshtoken,
            };

            var querystring = require("querystring");
            localStorage.setItem("tokenRefreshWindow", new Date(3000, 1, 1));
            return axios
                .post(
                    localConfig.authenticationURL + "/connect/token",
                    querystring.stringify(payload),
                    { headers: headers }
                )
                .then((response) => {
                    localStorage.setItem("access_token", response.data.access_token);
                    localStorage.setItem("refresh_token", response.data.refresh_token);
                    console.log("access token refreshed");
                    // resolve(response);
                })
                .catch((error) => {
                    console.log("Refresh token invalid or revoked");
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("refresh_token");

                    //    reject(error);
                });
            //   });
        },

        refreshAccessToken: () => {
            console.log("Refreshing Token");
            return new Promise((resolve, reject) => {
                let headers = {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: "",
                };

                let payload = {
                    grant_type: "refresh_token",
                    client_id: CLIENT_ID,
                    scope: SCOPE + " offline_access",
                    refresh_token: localStorage.getItem("refresh_token"),
                    ps_client: localConfig.Ps_Client,
                };

                var querystring = require("querystring");

                localStorage.setItem("tokenRefreshWindow", new Date(3000, 1, 1));
                axios
                    .post(
                        localConfig.authenticationURL + "/connect/token",
                        querystring.stringify(payload),
                        { headers: headers }
                    )
                    .then((response) => {
                        if (response != undefined) {
                            let accessToken = response.data.access_token;
                            localStorage.setItem("token", accessToken);
                            localStorage.setItem(
                                "refresh_token",
                                response.data.refresh_token
                            );
                            axios.defaults.headers.common["Authorization"] =
                "Bearer " + accessToken;

                            var parsedToken = parseJwt(accessToken);
                            localStorage.setItem(
                                "tokenRefreshWindow",
                                new Date((parsedToken.exp - TOKEN_REFRESH_TIMESPAN) * 1000)
                            );

                            resolve(response);
                        } else {
                            reject({ message: "Expired refresh token" });
                        }
                    })
                    .catch((error) => {
                        localStorage.removeItem("token");
                        localStorage.removeItem("refresh_token");
                        console.log(error);
                        reject(error);
                    });
            });
        },
        getClientPacket: (context, data) => {
            const psClientGuid = data[0];
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        localConfig.authenticationURL + "/api/ClientPacket/" + psClientGuid
                    )
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        generateMfaSecret: () => {
            return new Promise((resolve, reject) => {
                axios
                    .get(localConfig.authenticationURL + "/api/mfa/GenerateSecret")
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },

    getters: {
        isAuthenticated: (state) => !!state.token,
        parsedToken: (state) => parseJwt(state.token),
        authStatus: (state) => state.status,
        ssoOption: (state) => state.ssoOption,
        currentUser: state => state.currentUser,
        menus: (state, getters) => {
            if (getters.isAuthenticated) {
                return [{ name: "Logout", route: "Logout" }];
            }
            return [
                // { name: "Account Login", route: "Login" },
                // { name: "Reset Password", route: "ResetPassword" }
            ];
        },
    },
});
